import { Pipe } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'moment'
})
export class MomentPipe {
  transform(value, args, format?) {
    args = args || '';
    return args === 'ago' ? moment(value).fromNow() : moment(value, format).format(args);
  }
}
